export interface Example {
  text: string;
  bucket: 'current-state' | 'problem-opportunity' | 'ramifications';
  explanation?: string;
}

export const currentStateExamples: Example[] = [
  {
    text: 'We have revenue split evenly between partners.',
    bucket: 'current-state',
    explanation: 'This is an observable fact about the current business structure.'
  },
  {
    text: 'We have no packaging for Wes\'s intellectual property.',
    bucket: 'current-state',
    explanation: 'This describes a factual condition that exists today.'
  },
  {
    text: 'All client delivery is performed by Harry.',
    bucket: 'current-state',
    explanation: 'This is a verifiable statement about how work is currently done.'
  },
  {
    text: 'We have two different photo libraries.',
    bucket: 'current-state',
    explanation: 'This is a concrete, observable fact about the current state.'
  }
];

export const problemOpportunityExamples: Example[] = [
  {
    text: 'The business is structurally dependent on Harry\'s capacity.',
    bucket: 'problem-opportunity',
    explanation: 'This interprets the facts and identifies the core structural issue.'
  },
  {
    text: 'Our IP isn\'t translating into offerings clients can buy.',
    bucket: 'problem-opportunity',
    explanation: 'This explains the meaning of the current state — a functional gap.'
  },
  {
    text: 'We\'re losing the ability to find meaningful photos when we need them.',
    bucket: 'problem-opportunity',
    explanation: 'This describes the core tension created by having two photo libraries.'
  },
  {
    text: 'Our priorities are not aligned with our most urgent needs.',
    bucket: 'problem-opportunity',
    explanation: 'This identifies the mismatch between what is and what should be.'
  }
];

export const ramificationsExamples: Example[] = [
  {
    text: 'If we don\'t change this, the business will stall or collapse.',
    bucket: 'ramifications',
    explanation: 'This clearly states the consequence of inaction.'
  },
  {
    text: 'If nothing changes, Harry will have to seek outside income.',
    bucket: 'ramifications',
    explanation: 'This describes what will happen if the current state continues.'
  },
  {
    text: 'If we wait longer, the problem will grow exponentially.',
    bucket: 'ramifications',
    explanation: 'This articulates the urgency and escalating cost of delay.'
  },
  {
    text: 'If this persists, our work will outpace our ability to capture value.',
    bucket: 'ramifications',
    explanation: 'This states the stake — what we stand to lose if nothing changes.'
  }
];

export const allExamples: Example[] = [
  ...currentStateExamples,
  ...problemOpportunityExamples,
  ...ramificationsExamples
];



